"use strict";
var $ = require("jquery");
var ImageZoomMode;
(function (ImageZoomMode) {
    ImageZoomMode[ImageZoomMode["PhotoSwipe"] = 1] = "PhotoSwipe";
    ImageZoomMode[ImageZoomMode["NativeApp"] = 2] = "NativeApp";
})(ImageZoomMode || (ImageZoomMode = {}));
var ImageZoomUtils = (function () {
    function ImageZoomUtils() {
    }
    ImageZoomUtils.setNativeAppMode = function (appMobileHandler) {
        this.zoomMode = ImageZoomMode.NativeApp;
        this.appMobileHandler = appMobileHandler;
    };
    ImageZoomUtils.init = function (rootEl) {
        var _this = this;
        if (!rootEl)
            rootEl = window.document;
        $(rootEl).find("[image-zoom]").each(function (index, el) {
            var $el = $(el);
            var $images = $el.find("img[data-width][data-height]").not("a img");
            if ($images.length === 0)
                return;
            // Отображать картинки в галерее, с возможностью листания
            var gallery = !!$el.attr("image-zoom");
            var items = [];
            $images.each(function (i, img) {
                var $img = $(img);
                var src = $(img).attr("data-src-orig") ||
                    $img.attr("data-src") ||
                    $img.attr("src");
                if (src && src.indexOf("?") > 0 && src.indexOf(window.location.hostname) > 0) {
                    src = src.split("?")[0];
                }
                if (_this.zoomMode === ImageZoomMode.PhotoSwipe) {
                    var item = {
                        src: src,
                        w: $img.attr("data-width"),
                        h: $img.attr("data-height")
                    };
                    items.push(item);
                }
                else {
                    items.push(src);
                }
            });
            var self = _this;
            $images.each(function (index, img) {
                $(img).on("click", function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var options = {
                        index: index,
                        bgOpacity: 0.7,
                        arrowEl: gallery,
                        history: true,
                        getThumbBoundsFn: function () { return _this.getThumbBounds(img); }
                    };
                    if (_this.zoomMode === ImageZoomMode.PhotoSwipe) {
                        self.photoSwipe = new PhotoSwipe($(".pswp")[0], PhotoSwipeUI_Default, items, options);
                        self.photoSwipe.init();
                    }
                    else {
                        try {
                            _this.appMobileHandler.nativeImageZoom(index, items);
                        }
                        catch (ex) {
                            console.error("Image zoom error: ", ex);
                        }
                    }
                });
            });
        });
    };
    /*
     * Инициализация дом материалов к книге
     */
    ImageZoomUtils.initWorkMaterials = function () {
        var $figures = $("#masonry figure");
        if (!$figures[0] || this.zoomMode !== ImageZoomMode.PhotoSwipe)
            return;
        var items = [];
        $figures.each(function (i, el) {
            var $link = $(el).find("a");
            var item = {
                src: $link.attr("href"),
                w: $link.data("width"),
                h: $link.data("height"),
                title: $(el).find("figcaption").text()
            };
            items.push(item);
        });
        var pswp = $(".pswp")[0];
        var self = this;
        $figures.off("click");
        $figures.on("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            var index = $figures.index($(this));
            var options = {
                index: index,
                bgOpacity: 0.7,
                history: true,
                showHideOpacity: true
            };
            // Initialize PhotoSwipe
            self.photoSwipe = new PhotoSwipe(pswp, PhotoSwipeUI_Default, items, options);
            self.photoSwipe.init();
        });
    };
    ImageZoomUtils.photoSwipe = null;
    ImageZoomUtils.zoomMode = ImageZoomMode.PhotoSwipe;
    ImageZoomUtils.getThumbBounds = function (img) {
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        var rect = img.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
    };
    return ImageZoomUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ImageZoomUtils;
//# sourceMappingURL=imageZoomUtils.js.map